// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  min-height: calc(100vh - 200px);
}

.hero-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 120px 20px;
  text-align: center;
  color: white;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
  letter-spacing: -1px;
}

.hero-subtitle {
  font-size: 24px;
  font-weight: 300;
  opacity: 0.95;
}

.main-section {
  padding: 80px 20px;
  background-color: #f8f9fa;
  min-height: 300px;
}

.content-placeholder {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.content-placeholder h2 {
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 20px;
  font-weight: 600;
}

.content-placeholder p {
  font-size: 18px;
  color: #495057;
  line-height: 1.6;
  margin: 10px 0;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 80px 20px;
  }
  
  .hero-title {
    font-size: 32px;
  }
  
  .hero-subtitle {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".home-page {\n  min-height: calc(100vh - 200px);\n}\n\n.hero-section {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 120px 20px;\n  text-align: center;\n  color: white;\n}\n\n.hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.hero-title {\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  letter-spacing: -1px;\n}\n\n.hero-subtitle {\n  font-size: 24px;\n  font-weight: 300;\n  opacity: 0.95;\n}\n\n.main-section {\n  padding: 80px 20px;\n  background-color: #f8f9fa;\n  min-height: 300px;\n}\n\n.content-placeholder {\n  text-align: center;\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 40px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.content-placeholder h2 {\n  font-size: 28px;\n  color: #2c3e50;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n.content-placeholder p {\n  font-size: 18px;\n  color: #495057;\n  line-height: 1.6;\n  margin: 10px 0;\n}\n\n@media (max-width: 768px) {\n  .hero-section {\n    padding: 80px 20px;\n  }\n  \n  .hero-title {\n    font-size: 32px;\n  }\n  \n  .hero-subtitle {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
